"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackType = exports.TrackKind = void 0;
var TrackKind;
(function (TrackKind) {
    TrackKind["Undefined"] = "undefined";
    TrackKind["Empty"] = "empty";
    TrackKind["Main"] = "main";
    TrackKind["Alternative"] = "alternative";
    TrackKind["Captions"] = "captions";
    TrackKind["Subtitles"] = "subtitles";
    TrackKind["Translation"] = "translation";
    TrackKind["Descriptions"] = "descriptions";
    TrackKind["Metadata"] = "metadata";
    TrackKind["Chapters"] = "chapters";
    TrackKind["Thumbnails"] = "thumbnails";
    TrackKind["Commentary"] = "commentary";
    TrackKind["Variant"] = "variant";
})(TrackKind || (exports.TrackKind = TrackKind = {}));
var TrackType;
(function (TrackType) {
    TrackType["Video"] = "video";
    TrackType["Audio"] = "audio";
    TrackType["Text"] = "text";
})(TrackType || (exports.TrackType = TrackType = {}));
//# sourceMappingURL=Track.js.map